module.exports = __webpack_public_path__ + "static/media/IOTSU_S1_AQX1.6130f58c.jpg";